import React from "react";

const OrderCard = ({ shipped, delivered, processing, width, height }) => {
  const date = new Date()
    return (
    <div>
      <div>
      <p className="text-gray-500">Today: {date.toLocaleDateString()}</p>
        <div className="p-3 flex flex-row justify-between items-center ">
        <div className="">
          <p>Processing</p>
          <div className="bg-gray-50 border-b-4 border-b-orange-500 px-4 py-3 rounded-sm  text-2xl">
            <p className="text-gray-500">{processing}</p>
          </div>
        </div>
        <div >
          <p>Shipped</p>
          <div className="bg-gray-50 border-b-4 border-b-cyan-500 px-4 py-3 rounded-sm  text-2xl">
            <p className="text-gray-500">{shipped}</p>
          </div>
        </div>
        <div >
          <p>Delivered</p>
          <div className="bg-gray-50 border-b-4 border-b-lime-500 px-4 py-3 rounded-sm  text-2xl">
            <p className="text-gray-500">{delivered}</p>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default OrderCard;
